import type { App } from 'vue'
import { hasPermi, hasAllPermi, hasRole } from './permission'

// 注册所有自定义指令
export function setupDirectives(app: App) {
  // 权限指令
  app.directive('hasPermi', hasPermi)
  app.directive('hasAllPermi', hasAllPermi)
  app.directive('hasRole', hasRole)
}

export { hasPermi, hasAllPermi, hasRole }
